// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PRIVACY POLICY PAGE */
.pp-page {
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif;
}

/* HEADER */
.pp-header {
  padding: 40px 80px;
  border-bottom: 1px solid #2a2a2a;
}

.pp-logo {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.pp-logo-conscious {
  font-size: 28px;
  font-weight: 300;
  color: #ffffff;
  line-height: 1;
}

.pp-logo-karma {
  font-size: 28px;
  font-weight: 700;
  color: #f59255;
  letter-spacing: 4px;
  line-height: 1;
  margin-top: 2px;
}

/* MAIN CONTENT */
.pp-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 60px 40px 80px;
}

.pp-title {
  font-size: 48px;
  font-weight: 400;
  margin-bottom: 30px;
  text-align: center;
  color: #ffffff;
}

.pp-intro {
  font-size: 20px !important;
  line-height: 1.6;
  margin-bottom: 16px;
  /* Changed from 48px to 16px */
  text-align: left;
  color: #e0e0e0;
  font-weight: 300;
}

.pp-section {
  margin-bottom: 48px;
  background-color: #000000 !important;
}

.pp-heading {
  font-size: 25px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #f59255;
}

.pp-subheading {
  font-size: 22px;
  font-weight: 600;
  margin-top: 24px;
  margin-bottom: 12px;
  color: #ffaa5b;
}

.pp-text {
  font-size: 20px;
  line-height: 1.6;
  margin-bottom: 16px;
  color: #cccccc;
  text-align: left;
}

.pp-list {
  margin: 16px 0;
  padding-left: 0;
  list-style-position: inside;
}

.pp-list-item {
  font-size: 20px;
  line-height: 1.6;
  margin-bottom: 16px;
  color: #cccccc;
  text-align: left;
}

.pp-list-ordered {
  list-style-type: decimal;
}

.pp-contact {
  font-size: 20px;
  font-weight: 600;
  color: #f59255;
}

.pp-divider {
  display: none;
}

/* FOOTER */
.pp-footer {
  background: #0a0a0a;
  border-top: 1px solid #2a2a2a;
  padding: 30px 40px;
  text-align: center;
  color: #888888;
  font-size: 14px;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .pp-header {
    padding: 30px 20px;
  }

  .pp-logo-conscious,
  .pp-logo-karma {
    font-size: 22px;
  }

  .pp-content {
    padding: 40px 20px 60px;
  }

  .pp-title {
    font-size: 36px;
    margin-bottom: 40px;
  }

  .pp-heading {
    font-size: 24px;
  }

  .pp-subheading {
    font-size: 20px;
  }

  .pp-text,
  .pp-list-item {
    font-size: 16px;
  }
}

/* MOBILE FOOTER (match screenshot) */
@media (max-width: 640px) {
  .pp-footer {
    background: #000000 !important;
    border-top: none !important;
    padding: 12px 0 !important;
    color: #ffffff !important;
  }

  .pp-footer .container {
    gap: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .pp-footer nav {
    width: 100%;
  }

  .pp-footer .pp-footer-links {
    line-height: 1.25;
  }

  .pp-footer nav a {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 12px;
    text-decoration: none;
  }

  .pp-footer .pp-footer-sep {
    margin: 0 8px;
    color: #ffffff;
    font-weight: 700;
  }

  .pp-footer .pp-footer-break {
    flex-basis: 100%;
    height: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/PrivacyPolicy.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iFAAiF;AACnF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":["/* PRIVACY POLICY PAGE */\r\n.pp-page {\r\n  min-height: 100vh;\r\n  background: #000000;\r\n  color: #ffffff;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", system-ui, sans-serif;\r\n}\r\n\r\n/* HEADER */\r\n.pp-header {\r\n  padding: 40px 80px;\r\n  border-bottom: 1px solid #2a2a2a;\r\n}\r\n\r\n.pp-logo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n}\r\n\r\n.pp-logo-conscious {\r\n  font-size: 28px;\r\n  font-weight: 300;\r\n  color: #ffffff;\r\n  line-height: 1;\r\n}\r\n\r\n.pp-logo-karma {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  color: #f59255;\r\n  letter-spacing: 4px;\r\n  line-height: 1;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* MAIN CONTENT */\r\n.pp-content {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  padding: 60px 40px 80px;\r\n}\r\n\r\n.pp-title {\r\n  font-size: 48px;\r\n  font-weight: 400;\r\n  margin-bottom: 30px;\r\n  text-align: center;\r\n  color: #ffffff;\r\n}\r\n\r\n.pp-intro {\r\n  font-size: 20px !important;\r\n  line-height: 1.6;\r\n  margin-bottom: 16px;\r\n  /* Changed from 48px to 16px */\r\n  text-align: left;\r\n  color: #e0e0e0;\r\n  font-weight: 300;\r\n}\r\n\r\n.pp-section {\r\n  margin-bottom: 48px;\r\n  background-color: #000000 !important;\r\n}\r\n\r\n.pp-heading {\r\n  font-size: 25px;\r\n  font-weight: 600;\r\n  margin-bottom: 24px;\r\n  color: #f59255;\r\n}\r\n\r\n.pp-subheading {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  margin-top: 24px;\r\n  margin-bottom: 12px;\r\n  color: #ffaa5b;\r\n}\r\n\r\n.pp-text {\r\n  font-size: 20px;\r\n  line-height: 1.6;\r\n  margin-bottom: 16px;\r\n  color: #cccccc;\r\n  text-align: left;\r\n}\r\n\r\n.pp-list {\r\n  margin: 16px 0;\r\n  padding-left: 0;\r\n  list-style-position: inside;\r\n}\r\n\r\n.pp-list-item {\r\n  font-size: 20px;\r\n  line-height: 1.6;\r\n  margin-bottom: 16px;\r\n  color: #cccccc;\r\n  text-align: left;\r\n}\r\n\r\n.pp-list-ordered {\r\n  list-style-type: decimal;\r\n}\r\n\r\n.pp-contact {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f59255;\r\n}\r\n\r\n.pp-divider {\r\n  display: none;\r\n}\r\n\r\n/* FOOTER */\r\n.pp-footer {\r\n  background: #0a0a0a;\r\n  border-top: 1px solid #2a2a2a;\r\n  padding: 30px 40px;\r\n  text-align: center;\r\n  color: #888888;\r\n  font-size: 14px;\r\n}\r\n\r\n/* RESPONSIVE */\r\n@media (max-width: 768px) {\r\n  .pp-header {\r\n    padding: 30px 20px;\r\n  }\r\n\r\n  .pp-logo-conscious,\r\n  .pp-logo-karma {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .pp-content {\r\n    padding: 40px 20px 60px;\r\n  }\r\n\r\n  .pp-title {\r\n    font-size: 36px;\r\n    margin-bottom: 40px;\r\n  }\r\n\r\n  .pp-heading {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .pp-subheading {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .pp-text,\r\n  .pp-list-item {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n/* MOBILE FOOTER (match screenshot) */\r\n@media (max-width: 640px) {\r\n  .pp-footer {\r\n    background: #000000 !important;\r\n    border-top: none !important;\r\n    padding: 12px 0 !important;\r\n    color: #ffffff !important;\r\n  }\r\n\r\n  .pp-footer .container {\r\n    gap: 0 !important;\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pp-footer nav {\r\n    width: 100%;\r\n  }\r\n\r\n  .pp-footer .pp-footer-links {\r\n    line-height: 1.25;\r\n  }\r\n\r\n  .pp-footer nav a {\r\n    color: #ffffff !important;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .pp-footer .pp-footer-sep {\r\n    margin: 0 8px;\r\n    color: #ffffff;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .pp-footer .pp-footer-break {\r\n    flex-basis: 100%;\r\n    height: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
